import Api from '@/api';

const isAuthenticated = state => {
  const hgUserCookie = Api.authService.getAuthToken();
  const inAuthStore = state.Auth.user && state.Auth.user.access_token;

  return !!(inAuthStore || hgUserCookie);
};

export default { isAuthenticated };
